export default {
  name: 'boat',
  config: {
    baseURL: process.env.VUE_APP_API_BASE_URL
  }
};
